import angular from 'angular'
import escape from 'lodash/escape'

/**
 * Filter for highlight a keyword in a string
 *
 * @module vend.ui.vdHighlightText
 */
angular.module('vend.ui').filter('vdHighlightText', function ($sce) {
  /**
   * Escape a given string to be used safely in new RegExp() as a string match rather than interpreted as a regular expression.
   *
   * @param {String} text
   *        The text to escape for safe use in a regular expression
   *
   * Taken from https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
   */
  function escapeRegexp(text = '') {
    return text.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1')
  }

  /**
   * Highlights a keyword given a text
   *
   * @param {String} text
   *        Text to find a keyword
   *
   * @param {String} keyword
   *        keyword to be highlighted
   */
  return function (text, keyword) {
    text = escape(text || '')
    keyword = escape(keyword || '')

    if (!keyword || !text) {
      return $sce.trustAsHtml(text)
    }

    return $sce.trustAsHtml(
      text.replace(
        new RegExp(escapeRegexp(keyword), 'gi'),
        '<strong>$&</strong>'
      )
    )
  }
})
